import React from "react";
import Confetti from "react-dom-confetti";
import { Row, Col, Form, Modal, Button, Table } from "react-bootstrap";

class ClientAccountStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clients: [],
      activeClients: [],
      deactivatedClients: [],
      confettiTrigger: false,
      show: false,
      showDeleteModal: false,
      clientToDelete: null,
    };
  }

  componentDidMount() {
    this.setState({ clients: this.props.clients }, () => {
      this.sortClients();
    });

    $(".collapser").on("click", function () {
      $(this).next(".collapse").collapse("toggle");
      var icon = $(this).find(".fas");
      if (icon.hasClass("fa-sort-up")) {
        icon.removeClass("fa-sort-up").addClass("fa-sort-down");
      } else {
        icon.removeClass("fa-sort-down").addClass("fa-sort-up");
      }
    });
  }

  sortClients() {
    const newActiveClients = this.state.clients.filter((c) => c.active);
    const newDeactivatedClients = this.state.clients.filter((c) => !c.active);
    this.setState({ activeClients: newActiveClients, deactivatedClients: newDeactivatedClients });
  }

  handleShowDeleteModal = (client) => {
    this.setState({ showDeleteModal: true, clientToDelete: client });
  };

  handleHideDeleteModal = () => {
    this.setState({ showDeleteModal: false, clientToDelete: null });
  };

  confirmDeleteClient = () => {
    if (this.state.clientToDelete) {
      $.ajax({
        type: "POST",
        url: "/datapulse/client-management/remove-client/" + this.state.clientToDelete.client_company_id,
        success: () => {
          this.setState({ showDeleteModal: false, clientToDelete: null });
          this.sortClients(); // Re-sort clients after deletion
        }
      });
    }
  };

  deleteClient(client) {
    $.ajax({
      type: "POST",
      url: "/datapulse/client-management/remove-client/" + client.client_company_id,
    });
  }

  changeActiveStatus(client, active) {
    let successMsg = active ? "Client successfully activated" : "Client successfully deactivated";
    let failureMsg = active ? "Client failed to activate" : "Client failed to deactivate";
    // const activateMsg = active ?  `Do you want to reactivate ${client.company_name}?` : `Are you sure? ${client.company_name} will be deactivated.`
    // if (confirm(activateMsg) == true) {
      $.ajax({
        type: "POST",
        url: "/datapulse/client-management/activate-deactivate/" + client.id,
        dataType: "json",
        data: {
          id: client.id,
          active: active,
        },
        success: (data) => {
          this.setState({ confettiTrigger: true });
          DP_FLASH([{ type: "success", message: successMsg }]);
          client.active = active;
          this.sortClients();
          this.setState({ confettiTrigger: false });
        },
        failure: (data) => {
          DP_FLASH([{ type: "danger", message: failureMsg }]);
        },
      });
    // }
  }

  render() {
    const confettiConfig = {
      angle: "85",
      spread: "83",
      startVelocity: "30",
      elementCount: "125",
      dragFriction: "0.03",
      duration: "5000",
      stagger: "0",
      width: "8px",
      height: "31px",
      perspective: "1000px",
      colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
    };
    const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;

    return (
      <div>
        <div className="standard-page-padding">
          <h1>Client Management</h1>
          <div className="d-flex justify-content-end">
            <Button className="lite-btn btn-success" onClick={(e) => this.setState({ show: true })}>
              +&nbsp;&nbsp;New client
            </Button>
          </div>
          <div className="mt-5 table-responsive client-management-table">
            <Table striped className="mt-2 table-white">
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Last Change</th>
                  <th>Client Name</th>
                  <th>Activation Date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.activeClients.map((client) => {
                  return (
                    <tr key={client.id}>
                      <td>
                        <Form.Check type="switch" id={"custom-switch-" + client.id} checked onChange={(e) => this.changeActiveStatus(client, false)} />
                      </td>
                      <td>{new Date(Date.parse(client.updated_at)).toLocaleDateString()}</td>
                      <td>{client.company_name}</td>
                      <td>{new Date(Date.parse(client.created_at)).toLocaleDateString()}</td>
                      <td></td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
          {this.props.current_user_is_admin && (
            <div className="mt-5">
              <div className="float-left">
                <h5>Archive</h5>
              </div>
              <div className="collapser float-right" data-toggle="collapse">
                <p style={{ fontSize: "16px" }} className="text-primary mb-0">
                  Collapse Section&nbsp;<i className="fas fa-sort-down"></i>
                </p>
              </div>
              <div className="collapse pt-4 clear-both">
                <div className="table-responsive client-management-table">
                  <Table striped className="table-white">
                    <thead>
                      <tr>
                        <th>Status</th>
                        <th>Last Change</th>
                        <th>Client Name</th>
                        <th>Activation Date</th>
                        <th className="text-danger">Danger Zone</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.deactivatedClients.map((client) => {
                        return (
                          <tr key={client.id}>
                            <td>
                              <Form.Check type="switch" id={"custom-switch-" + client.id} onChange={(e) => this.changeActiveStatus(client, true)} />
                            </td>
                            <td>{new Date(Date.parse(client.updated_at)).toLocaleDateString()}</td>
                            <td>{client.company_name}</td>
                            <td>{new Date(Date.parse(client.created_at)).toLocaleDateString()}</td>
                            <td>
                              <Button className="lite-btn btn-danger lite-btn-sm" onClick={(e) => this.handleShowDeleteModal(client)}>
                                Delete client
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
              <div className="clear-both"></div>
            </div>
          )}
        </div>

        <Row style={{ marginTop: "40vh", display: this.state.confettiTrigger ? "block" : "none" }} className="justify-content-center">
          <Col md={1}>
            <div>
              <Confetti active={this.state.confettiTrigger} config={confettiConfig} />
            </div>
          </Col>
        </Row>
        <Modal className="create-new-client-modal" show={this.state.show} onHide={(e) => this.setState({ show: false })} style={{ textAlign: "center" }}>
          <div className="page-1">
            <Modal.Header closeButton>
              {" "}
              <Row className="mb-2 justify-content-center" style={{ margin: "auto" }}>
                <Col>
                  <h3>What is the name of the company?</h3>
                </Col>
              </Row>
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-5">
                <Col>
                  <p>
                    This field determines how this account will be displayed in DataPulse. <br></br>Just the simplest form of the company name is ideal.
                  </p>
                </Col>
              </Row>
              <Row className="justify-content-center pb-2">
                <Col className="name-input">
                  <form className="create-new-client" method="post">
                    <input hidden name="authenticity_token" value={authenticityToken} readOnly />
                    <input className="lite-input" defaultValue="" name="company_name" style={{ width: "591px", maxWidth: "100%" }} required />
                    <Row className="mt-5">
                      <Col>
                        <Button
                          size="lg"
                          style={{ marginLeft: "20px", width: "300px", maxWidth: "80%" }}
                          className="lite-btn btn-success"
                          type="submit">
                          Next
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </div>
        </Modal>

         <Modal show={this.state.showDeleteModal} onHide={this.handleHideDeleteModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              <h4>Delete Client</h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <p className="mb-4">Are you sure you want to permanently delete {this.state.clientToDelete ? this.state.clientToDelete.company_name : 'this client'}? All data associated with this client will be permanently deleted.</p>
              <button className="lite-btn btn-default mr-3" onClick={this.handleHideDeleteModal}>
                Cancel
              </button>
              <button className="lite-btn btn-danger" onClick={this.confirmDeleteClient}>
                Confirm
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default ClientAccountStatus;
